/* Beacon menu behaviour (2026-10-06).
   1. Escape closes a panel that was opened by the mouse, from anywhere on the page (WCAG 1.4.13 "dismissible").
      Horizon already handles Escape when focus is inside the menu.
   2. A panel stays open while its email field or button has focus, so moving the mouse away mid-typing does not
      make the form vanish. It closes when focus leaves and the pointer is not over it. */
(function () {
  if (window.__bcnMenuReady) return;
  window.__bcnMenuReady = true;
  var menu = document.querySelector('header-menu');
  if (!menu) return;

  function items() { return menu.querySelectorAll('.menu-list__list-item:not([slot])'); }
  function submenuOf(li) { return li.querySelector(':scope > .menu-list__submenu'); }
  function openItem() {
    var sub = menu.querySelector('.menu-list__list-item:not([slot]) > .menu-list__submenu:not([inert])');
    return sub ? sub.parentElement : null;
  }
  function closeItem(li) { li.dispatchEvent(new PointerEvent('pointerleave', { bubbles: false })); }

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var li = openItem();
    if (!li || menu.contains(event.target)) return;
    closeItem(li);
  });

  items().forEach(function (li) {
    var sub = submenuOf(li);
    if (!sub) return;
    // Runs before Horizon's own pointerleave handler (capture phase); untrusted events (ours) pass through.
    li.addEventListener('pointerleave', function (event) {
      if (!event.isTrusted) return;
      var a = document.activeElement;
      if (a && sub.contains(a) && a.matches('input, button')) event.stopImmediatePropagation();
    }, true);
    sub.addEventListener('focusout', function () {
      setTimeout(function () {
        if (!sub.contains(document.activeElement) && !li.matches(':hover') && !sub.hasAttribute('inert')) closeItem(li);
      }, 0);
    });
  });
})();
